import { defineMessages } from 'react-intl';

const messages = defineMessages({
  VideoContent: {
    id: 'Video Content',
    defaultMessage: 'Video Content',
  },
  Preview_image: {
    id: 'Preview Image URL',
    defaultMessage: 'Preview Image URL',
  },
  Url: {
    id: 'Video URL',
    defaultMessage: 'Video URL',
  },
  File: {
    id: 'Video File',
    defaultMessage: 'Video File',
  },
  Alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  VideoContentDescription: {
    id: 'This block displays the video from the content URL field',
    defaultMessage: 'This block displays the video from the content URL field',
  },
});

export const VideoContentBlockSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.VideoContent),
    block: 'videoContent',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['url', 'file', 'preview_image', 'align'],
      },
    ],
    properties: {
      url: {
        title: props.intl.formatMessage(messages.Url),
      },
      file: {
        title: props.intl.formatMessage(messages.File),
        widget: 'video_file_widget',
      },
      preview_image: {
        title: props.intl.formatMessage(messages.Preview_image),
        widget: 'url',
        description: props.intl.formatMessage(messages.VideoContentDescription),
      },
      align: {
        title: props.intl.formatMessage(messages.Alignment),
        widget: 'align',
      },
    },
    required: [],
  };
};

export default VideoContentBlockSchema;
